// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo_4f813eae {
  position: relative;
}
.logo_pointer_4f813eae {
  cursor: pointer;
}
.logo__icon_4f813eae {
  font-size: 1.75rem;
  color: #1d5080;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `logo_4f813eae`,
	"logo_pointer": `logo_pointer_4f813eae`,
	"logo__icon": `logo__icon_4f813eae`
};
export default ___CSS_LOADER_EXPORT___;
